import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLayers = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.9875 21.175L2.775 14.0125L0.75 15.5875L12 24.3375L23.25 15.5875L21.2125 14L11.9875 21.175ZM12 18L21.2 10.8375L23.25 9.25L12 0.5L0.75 9.25L2.7875 10.8375L12 18ZM12 3.6625L19.175 9.25L12 14.8375L4.825 9.25L12 3.6625Z",
		fill: "#5E6068"
	})
});
export { SvgLayers as ReactComponent };
